import * as React from "react";
import type { SVGProps } from "react";
const SvgSimplifyDelivery = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M29.34 14.703c-9.555 1.469-16.11 10.405-14.64 19.96 1.468 9.556 10.405 16.111 19.96 14.642 9.555-1.469 16.11-10.406 14.642-19.96-1.47-9.556-10.406-16.111-19.962-14.642Zm-16.589 20.26c-1.634-10.63 5.66-20.574 16.29-22.208 10.631-1.635 20.574 5.659 22.208 16.29 1.635 10.63-5.658 20.574-16.29 22.208-10.63 1.634-20.573-5.659-22.208-16.29Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M30.146 24.16a8.06 8.06 0 1 0 3.703 15.69 8.06 8.06 0 0 0-3.703-15.69Zm-7.912 10.15c-1.272-5.392 2.067-10.795 7.46-12.068 5.391-1.272 10.794 2.067 12.067 7.46 1.272 5.391-2.067 10.794-7.46 12.066-5.391 1.273-10.794-2.066-12.067-7.458Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M32 34.802a2.797 2.797 0 1 0 0-5.593 2.797 2.797 0 0 0 0 5.593Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32 6.618c-14.021 0-25.388 11.366-25.388 25.387S17.98 57.392 32 57.392c14.02 0 25.387-11.366 25.387-25.387S46.021 6.618 32 6.618ZM4.642 32.005C4.642 16.895 16.89 4.647 32 4.647c15.11 0 27.358 12.249 27.358 27.358 0 15.11-12.249 27.358-27.358 27.358-15.11 0-27.358-12.248-27.358-27.358Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M32 10.31a4.663 4.663 0 1 0 0-9.325 4.663 4.663 0 0 0 0 9.325Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32 1.97a3.677 3.677 0 1 0 0 7.355 3.677 3.677 0 0 0 0-7.354Zm-5.648 3.678a5.648 5.648 0 1 1 11.295 0 5.648 5.648 0 0 1-11.295 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M9.173 23.486a4.663 4.663 0 1 0 0-9.325 4.663 4.663 0 0 0 0 9.325Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M9.173 15.147a3.677 3.677 0 1 0 0 7.354 3.677 3.677 0 0 0 0-7.354Zm-5.648 3.677a5.648 5.648 0 1 1 11.296 0 5.648 5.648 0 0 1-11.296 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M9.173 49.839a4.663 4.663 0 1 0 0-9.326 4.663 4.663 0 0 0 0 9.326Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M9.173 41.499a3.677 3.677 0 1 0 0 7.354 3.677 3.677 0 0 0 0-7.354Zm-5.648 3.677a5.648 5.648 0 1 1 11.296 0 5.648 5.648 0 0 1-11.296 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M32 63.014a4.663 4.663 0 1 0 0-9.325 4.663 4.663 0 0 0 0 9.325Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32 54.675a3.677 3.677 0 1 0 0 7.354 3.677 3.677 0 0 0 0-7.354Zm-5.648 3.677a5.648 5.648 0 1 1 11.295 0 5.648 5.648 0 0 1-11.295 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M54.826 49.839a4.663 4.663 0 1 0 0-9.326 4.663 4.663 0 0 0 0 9.326Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M54.826 41.499a3.677 3.677 0 1 0 0 7.354 3.677 3.677 0 0 0 0-7.354Zm-5.648 3.677a5.648 5.648 0 1 1 11.296 0 5.648 5.648 0 0 1-11.296 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M54.826 23.486a4.663 4.663 0 1 0 0-9.325 4.663 4.663 0 0 0 0 9.325Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M54.826 15.147a3.677 3.677 0 1 0 0 7.354 3.677 3.677 0 0 0 0-7.354Zm-5.648 3.677a5.648 5.648 0 1 1 11.296 0 5.648 5.648 0 0 1-11.296 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSimplifyDelivery;
